<template>
    <div class="goods-box my-form">  
        <!-- <img v-if="user && user.avatarUrl" :src="user.avatarUrl"> -->
    
        <div  v-if="formData && formData.length" class="custom-form">
            <van-form @submit="onSubmit" label-width="1.85rem" class="reg_from" show-error :show-error-message="false" :scroll-to-error="true">
                <template v-for="(item, index) in formData" >
                    <!-- 单行文本 -->
                    <div class="cell-box" v-if="item.tagType === 0" :key="'form' + index">
                        <van-field
                            v-model="formModel[index]['model' + index]"
                            :name="item.label"
                            :label="item.label"
                            :placeholder="item.attributes.placeholder || '请输入'"
                            :required="item.attributes.checkOptions.require"
                            :rules="[{required: item.attributes.checkOptions.require, message: '验证错误'}]"
                            :ref="['model' + index]"
                        />
                        <template v-if="item.label === '手机'"> 
                            <van-field
                                v-model="code"
                                center
                                clearable
                                label="验证码"
                                maxlength="6"
                                placeholder="请输入验证码"
                                required
                                :rules="[{ required: true, message: '请输入验证码' }]"
                                v-if="item.tagType === 0" 
                                :key="'c' + index"
                                >
                                <template #button>
                                    <span class="code" v-if="newTimer">{{ newCount || 0}}s重新发送</span>
                                    <span class="sendcode code" v-else @click="getCode(formModel[index]['model' + index])">发送验证码</span>
                                </template>
                            </van-field>
                        </template>
                    </div>
                    <!-- 单行文本 -->

                    <!-- 多行文本输入框 -->
                    <div class="cell-box" v-if="item.tagType === 1" :key="'form' + index">
                        <div class="cell">
                            <p class="cell-title no-border" :class="item.attributes.checkOptions.require ? 'require' : ''">{{item.label}}</p>
                            <van-field
                                v-model="formModel[index]['model' + index]"
                                rows="4"
                                type="textarea"
                                class="intro_cell"
                                maxlength="500"
                                :name="item.label"
                                :placeholder="item.attributes.placeholder || '请输入'"
                                :rules="[{ required: item.attributes.checkOptions.require, message: '验证错误' }]"
                                :ref="['model' + index]"
                            />
                        </div>
                     </div>
                    <!-- /多行文本输入框 -->

                    <!-- 数字输入框 -->
                    <div class="cell-box" v-if="item.tagType === 2" :key="'form' + index">
                        <van-field 
                            v-model="formModel[index]['model' + index]"
                            type="digit" 
                            :label="item.label"
                            :placeholder="item.attributes.placeholder || '请输入'"
                            :ref="['model' + index]"
                            :required="item.attributes.checkOptions.require"
                            :rules="[{ required: item.attributes.checkOptions.require, message: '验证错误'}]"
                        />
                    </div>
                    <!-- 数字输入框 -->

                    <!-- 下拉选择框 -->
                    <div class="cell-box" v-if="item.tagType === 3" :key="'form' + index">
                        <van-field
                            readonly
                            clickable
                            :name="item.label"
                            :label="item.label"
                            :value="formModel[index]['model' + index]"
                            :placeholder="item.attributes.placeholder || '请选择'"
                            @click="formModel[index].isShow = true ; curIndex = index"
                            :required="item.attributes.checkOptions.require"
                            :rules="[{ required: item.attributes.checkOptions.require, message: '验证错误' }]"
                            />
                            <van-popup v-model="formModel[index].isShow" position="bottom">
                            <van-picker
                                show-toolbar
                                :columns="item.columns"
                                @confirm="confirm($event,'1')"
                                @cancel="formModel[index].isShow = false"
                                />
                            </van-popup>
                    </div>
                    <!-- 下拉选择框 -->

                    <!-- 单选框 -->
                    <div class="cell-box" v-if="item.tagType === 4" :key="'form' + index">
                        <div class="cell cell-1">
                            <p class="cell-title no-border" :class="item.attributes.checkOptions.require ? 'require' : ''">{{item.label}}</p>
                            <div class="yd-checkbox_wrap">
                                    <van-radio-group 
                                        v-model="formModel[index]['model' + index]" 
                                    >
                                        <div  v-for="(opt,i) in item.attributes.options" :key="'checkbox' + i + index" class="yd-checkbox-list">
                                            <!-- <template v-if="opt.label !== 'other'"> -->
                                                <van-radio :name="opt.value">{{opt.value}}</van-radio>
                                            <!-- </template> -->
                                        </div>
                                    </van-radio-group>
                            </div>
                        </div>
                    </div>
                    <!-- 单选框 -->

                    <!-- 多选框 -->
                    <div class="cell-box" v-if="item.tagType === 5" :key="'form' + index">
                        <div class="cell cell-1">
                            <p class="cell-title no-border" :class="item.attributes.checkOptions.require ? 'require' : ''">{{item.label}}</p>
                            <div class="yd-checkbox_wrap">
                                    <van-checkbox-group 
                                        v-model="formModel[index]['model' + index]" 
                                    >
                                        <div  v-for="(opt,i) in item.attributes.options" :key="'checkbox' + i + index" class="yd-checkbox-list">
                                            <!-- <template v-if="opt.label !== 'other'"> -->
                                                <van-checkbox :name="opt.value" shape="square">{{opt.value}}</van-checkbox>
                                            <!-- </template> -->
                                        </div>
                                    </van-checkbox-group>
                            </div>
                        </div>
                    </div>
                    <!-- 多选框 -->
                    
                    <!-- 日期框 -->
                    <div class="cell-box" v-if="item.tagType === 6" :key="'form' + index">
                        <van-field
                            readonly
                            clickable
                            name="datetimePicker"
                            v-model="formModel[index]['model' + index]"
                            :label="item.label"
                            :placeholder="item.attributes.placeholder || '请选择日期'"
                            :required="item.attributes.checkOptions.require"
                            :rules="[{ required: item.attributes.checkOptions.require, message: '验证错误' }]"
                            @click="formModel[index].isShow = true; curIndex = index"
                            />
                            <van-popup v-model="formModel[index].isShow" position="bottom">
                            <van-datetime-picker
                                type="date"
                                :min-date="minDate"
                                :max-date="maxDate"
                                @confirm="confirm($event,'2')"
                                @cancel="formModel[index].isShow = false"
                            />
                            </van-popup>
                    </div>

                    <!-- 日期框 -->

                    <!-- 日期区间 -->
                    <div class="cell-box" v-if="item.tagType === 7" :key="'form' + index">
                        <van-field
                        readonly
                        clickable
                        name="datetimePicker"
                        v-model="formModel[index]['model' + index][0].start"
                        :label="item.childrens[0].label"
                        :placeholder="item.attributes.placeholder || '请选择日期'"
                        :required="item.attributes.checkOptions.require"
                        :rules="[{ required: item.attributes.checkOptions.require, message: '验证错误' }]"
                        @click="formModel[index].isShow = true; curIndex = index; isStart = true;"
                        />
                        <van-popup v-model="formModel[index].isShow" position="bottom">
                        <van-datetime-picker
                            type="date"
                            :min-date="minDate"
                            :max-date="maxDate"
                            @confirm="confirm($event,'3')"
                            @cancel="formModel[index].isShow = false"
                        />
                        </van-popup>
                        <van-field
                        readonly
                        clickable
                        name="datetimePicker"
                        v-model="formModel[index]['model' + index][0].end"
                        :label="item.childrens[1].label"
                        :placeholder="item.attributes.placeholder || '请选择日期'"
                        :required="item.attributes.checkOptions.require"
                        :rules="[{ required: item.attributes.checkOptions.require, message: '验证错误' }]"
                        @click="formModel[index].isShow = true; curIndex = index; isStart = false;"
                        />
                        <van-popup v-model="formModel[index].isShow" position="bottom">
                        <van-datetime-picker
                            type="date"
                            :min-date="minDate"
                            :max-date="maxDate"
                            @confirm="confirm($event,'3')"
                            @cancel="formModel[index].isShow = false"
                        />
                        </van-popup>
                    </div>

                    <!-- 日期区间 -->

                    <!-- 说明文字 -->
                    <p v-if="item.tagType === 10" class="tipInfo" :key="'form' + index">{{item.attributes.value}}</p>
                    <!-- 说明文字 -->
                  
                    <!-- 套件 -->
                        <!-- 城市选择 -->
                    <div class="cell-box" v-if="item.tagType === 11 && item.label === '城市'" :key="'form' + index">
                        <van-field
                            readonly
                            clickable
                            name="area"
                            :label="item.label"
                            placeholder="请选择城市"
                            :value="formModel[index]['model' + index]"
                            @click="showArea = true ; curIndex = index"
                            required
                            :rules="[{ required: true, message: '验证错误' }]"
                            />
                            <van-popup v-model="showArea" position="bottom">
                            <van-area
                                :value="cityCode"
                                :area-list="areaList"
                                @confirm="onCity($event)"
                                @cancel="showArea = false"
                                />
                            </van-popup>
                        </div>
                        <!-- 城市选择 -->
                         
                        <!-- 感兴趣类别 -->
                        <div class="cell-box" v-if="item.tagType === 11 && item.label === '拟参展类别'" :key="'form' + index">
                            <van-field
                                readonly
                                clickable
                                :label="'拟参展类别'"
                                :value="formModel[index]['model' + index]"
                                :placeholder="'请选择'"
                                @click="formModel[index].isShow = true ; curIndex = index"
                                :required="item.attributes.checkOptions.require"
                                :rules="[{ required: item.attributes.checkOptions.require, message: '请选择' }]"
                                />
                                <van-popup v-model="formModel[index].isShow" position="bottom">
                                <van-picker
                                    show-toolbar
                                    :columns="Categorys"
                                    @confirm="confirmHall"
                                    @cancel="formModel[index].isShow = false"
                                    />
                                </van-popup>
                        </div>

                        <!-- 感兴趣类别 -->
                        
                        <!-- 展馆选择 -->
                        <div class="cell-box" v-if="item.tagType === 11 && item.label === '展馆选择'" :key="'form' + index">
                            <van-field
                                readonly
                                clickable
                                name="area"
                                :label="item.label"
                                placeholder="请选择展馆"
                                :value="formModel[index]['model' + index]"
                                @click="formModel[index].isShow = true ; curIndex = index"
                                :required="item.attributes.checkOptions.require"
                                :rules="[{ required: item.attributes.checkOptions.require, message: '验证错误' }]"
                                />
                                <van-popup v-model="formModel[index].isShow" position="bottom">
                                <van-picker
                                    show-toolbar
                                    :columns="hallList"
                                    @cancel="formModel[index].isShow = false"
                                    @confirm="confirmHall"
                                />
                                </van-popup>
                         </div>
                        <!-- 展馆选择 -->


                    <!-- 套件 -->

                </template>

                <!-- <div class="single-checkbox">
                    <van-checkbox v-model="checkbox" shape="square" />
                    <p>我已阅读并同意展商秀</p>
                    <span @click="showFrame=true">《注册服务条款》</span>
                </div> -->
                
                <div class="vant-btn">
                    <van-button round block type="info"  native-type="submit"> 保存 </van-button>
                </div>
            </van-form>
           
        </div>

    <!-- 注册条款 -->
    <frame :showFrame="showFrame" @agree="showFrame = false ; checkbox = true"></frame>

    <!-- 类别 -->
    <categoryPop ref="regCare" :cateList="categoryList" :selectList="categoryList1" @closePop="closePop"></categoryPop>

    </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import provincial from '@/assets/js/provincial.json';     //省市区json
import categoryPop from '../my-page/my-reg/categoryPop';   // 类别弹框
import frame from '../my-page/my-reg/frame';   // 条款弹框
import { moment } from '../../utils/utils';   // 时间处理
import { parse } from 'graphql';

export default {
    name:'custom-form',
    data(){
        return{
            formData:[], // 表单数据
            formId:'', // 自定义表单的id
            userformData:[], // 用户填写表单数据
            defaultItem: [ ], // 包含默认的手机，姓名，职务，公司,地址
            formModel: [], // 表单双向绑定数组 v-model Value  
            showArea:false,
            areaList:[], // 地区数据
            areavalue:[], // 选中的地区数据
            cityCode:'',  //省市区编号，默认
            curIndex:null,
            showPicker:false,
            minDate: new Date(2010, 0, 1),
            maxDate: new Date(2050, 10, 1),
            isStart:true, // 日期区间是否为第一个
            
            checkbox:false,
            showFrame:false, //  显示条款
            categoryNum:"",
            categoryList1: [], //感兴趣类型的选中数组
            showCategory:false, // 显示类别
            hallList:[], // 展馆列表
            
            form: {
                fullName: "", // 姓名
                phoneNumber: "", // 手机号
                compName: "", // 公司名
                categoies: '',
            },
            //验证码
            code:'',
            count: 0,
            newCount: 0,
            timer: null,
            newTimer: null,
            codeKey:'',
            //验证码
            currentDate:new Date(),
            Categorys:[], // 展品类别
            formUserId:'',
        }
    },
    components:{ frame,categoryPop },
    computed: {
        ...mapGetters({
            user: "getUserInfo",
            categoryList:'getCategory',
            userId:"getUserId",
            exhibitionId:'getExhibitionId'
        }),
        
    },
    created(){
        this.areaList=provincial;
        this.init();
    },
    methods:{
        ...mapActions({
            getCustomForm:'getCustomForm',
            getHallList:'getHallList',
            addCustomForm:'addCustomForm',
            getUserCustomForm:'getUserCustomForm',
            patchUser:'my/patchUser',
            patchUserCategory:'my/patchUserCategory',
            sendCode:'my/sendCode',
            validateCode:'my/validateCode',
            putPhone:'my/putPhone',
            regUser:'my/regUser',
            addExApply:'addExApply',
            linkToExApplyFinish:'linkTo/linkToExApplyFinish'
        }),
        async init(){
            let exhibitionId = this.$route.params.id;
            this.$store.commit("setExhibitionId",exhibitionId);
            await this.$Myapollo.getExhibitionInfo(this,exhibitionId,this.userId);
            await this.$Myapollo.getCategory(this,this.exhibitionId);
            this.categoryList.forEach(c => {
                this.Categorys.push(c.name);
            });
            await this.$Myapollo.getUserInfo(this);
            let reqBody = {
                where: {Equal: {N: "exhibitionId", V: exhibitionId},
                        Equal_isdeleted: {n: "isDeleted", v: false}
                },
                order: [{N: "showIndex", V: 0}]
            }
            let hall = await this.getHallList(reqBody);
            hall.map(c=>{
                this.hallList.push(c.name)
            })

            let form = await this.getCustomForm({id:exhibitionId,type:'show.form.exhibitor.reg'});
            // 判断是否需要加入默认选项 
            this.formId = form.id;
            this.formData = [...form.items];
            this.initFromData();
            // this.getuserFromData();
        },
        async getuserFromData(){ // 获取用户的表单数据
            let opt = {
                id:this.exhibitionId,
                type:'show.form.visitor.reg',
                userId:this.user.userId
            }
            this.userformData =  await this.getUserCustomForm(opt);
            if(!this.userformData) return;
            this.userformData.forEach(c=>{
                this.formModel.map((v,i)=>{
                    if(v.type == c.tagType && v.label == c.label){
                        v['model' + i] = c.value
                    }
                    if(v.type == c.tagType && v.label == c.label && v.type == 5){ // 多选
                        v['model' + i] =JSON.parse(c.value);
                    }
                    if(v.type == c.tagType && v.label == c.label && v.type == 11){ // 展品类别
                        if(c.value && v.label == '展品类别'){
                            this.form.category = c.value;
                            this.categoryList1 = c.value.split(';');
                            this.categoryNum = this.categoryList1.length;
                        }
                    }
                    if(v.type == c.tagType && c.label == v.labelParent && v.type == 7){ // 日期区间
                        c.childrens.forEach(e=>{
                            if(e.label == v.label[0]){
                                v['model' + i][0].start = e.value
                            }
                            if(e.label == v.label[1]){
                                v['model' + i][0].end = e.value
                            }
                        })
                    }
                })
            })
        },
        initFromData(){
            this.formData.map((v, i) => { 
                if(v.tagType === 0 && v.label === '姓名') {
                this.formModel.push({['model' + i]: '', index : i, validate: true, attributes: v.attributes, type: v.tagType, label: v.label});
                return;
                }  
                if(v.tagType === 0 && v.label === '手机') {
                this.formModel.push({['model' + i]: '', index : i, validate: true, attributes: v.attributes, type: v.tagType, label: v.label});
                return
                } 
                if(v.tagType === 0 && v.label === '职务') {
                this.formModel.push({['model' + i]: '', index : i, validate: true, attributes: v.attributes, type: v.tagType, label: v.label});
                return;
                } 
                if(v.tagType === 0 && v.label === '公司') {
                this.formModel.push({['model' + i]: '', index : i, validate: true, attributes: v.attributes, type: v.tagType, label: v.label});
                return;
                } 
                if (v.tagType === 11 && v.label === '城市') { 
                    let addr = ''
                    if (this.user.province && this.user.city && this.user.county) {
                        this.areavalue = [
                            this.user.province,
                            this.user.city,
                            this.user.county
                        ];
                        addr =
                            this.user.province +
                            "/" +
                            this.user.city +
                            "/" +
                            this.user.county;

                       
                        } else if (this.user.province && this.user.city) {
                        addr = this.user.province + "/" + this.user.city;
                        this.areavalue = [this.user.province, this.user.city];
                        } else {
                        addr = this.user.province;
                        this.areavalue = [this.user.province];
                    }
                this.formModel.push({['model' + i]: addr, index : i, validate: true, attributes: v.attributes, type: v.tagType, label: v.label});  
                return;
                }
                if (v.tagType === 11 && v.label === '拟参展类别') { 
                this.formModel.push({['model' + i]: '', index : i, isShow:false, validate: true, attributes: v.attributes, type: v.tagType, label: v.label});  
                return;
                }
                if (v.tagType === 11 && v.label === '展馆选择') { 
                this.formModel.push({['model' + i]: '', index : i, isShow:false, validate: true, attributes: v.attributes, type: v.tagType, label: v.label});  
                return;
                }
                if (v.tagType === 3) {  // 下拉框
                v.columns  = [];
                v.attributes.options.map(c=>{
                    v.columns.push(c.value);
                })
                this.formModel.push({['model' + i]: '', index : i, isShow:false, other: '', validate: false, attributes: v.attributes, type: v.tagType, label: v.label});
                return;
                }
                if (v.tagType === 4) {  // 单选框
                this.formModel.push({['model' + i]: '', index : i, other: '', validate: false, attributes: v.attributes, type: v.tagType, label: v.label});
                return;
                }
                if (v.tagType === 5) {  // 多选框
                this.formModel.push({['model' + i]: [], index : i, other: '', validate: false, attributes: v.attributes, type: v.tagType, label: v.label});
                return;
                }
                if (v.tagType === 6) {  // 日期框
                this.formModel.push({['model' + i]: '', index : i, isShow:false, other: '', validate: false, attributes: v.attributes, type: v.tagType, label: v.label});
                return;
                }
                if (v.tagType === 7) {   // 日期区间
                this.formModel.push({
                    ['model' + i]: [{start: '', end: ''}], 
                    index : i,
                    validate: false,
                    attributes: v.attributes,
                    isShow:false,
                    type: v.tagType, 
                    labelParent:v.label,
                    parentId:v.childrens[0].parentId,
                    label: [v.childrens[0].label, v.childrens[1].label], 
                    
                }); 
                return;
                }
                if (v.tagType === 10) {  // 文字说明
                this.formModel.push({['model' + i]: [], index : i, validate: true, attributes: v.attributes, type: v.tagType, label: v.label});
                return;
                }
                this.formModel.push({['model' + i]: '', index : i, validate: false, attributes: v.attributes, type: v.tagType, label: v.label});
            }); 
            console.log(this.formData,'处理后的表单数据')
            console.log(this.formModel,'双向绑定的数据')
            // this.formItems = this.formData;
        },
        onCity(e){ //选择地区
            console.log(e,'选择地区');
            let areaList = [];
            e.forEach(c => {
                areaList.push(c.name)
            });
            this.areavalue = areaList;
            this.showArea = false;
            // this.form.area = areaList.join("/");
            this.formModel[this.curIndex]['model' + this.curIndex] = areaList.join("/");
            console.log(this.formModel[this.curIndex]['model' + this.curIndex],'--')
        },
        regCareShow() { // 打开类别弹框
            this.$refs["regCare"].open();
        },
        closePop(checkList,vals) { // 选中类别并关闭弹框
            console.log(checkList,'选中的类别',vals);
            this.categoryNum = vals.length;
            this.form.category = checkList;
            this.categoryList1 = checkList.split(';');
            console.log(this.categoryList1,'this.categoryList1')
            console.log(this.form.category,'this.form.category')
        },
        async onSubmit(){  // 提交表单
            if(!this.validForm()) return; // 验证失败  
            // if (!this.checkbox) {
            //     this.$toast.fail('请确认同意服务条款');
            //     return;
            // }
            let checkRes =  await this.Checkphone();
            if(!checkRes) {
                return;
            }
            const formFill = await this.transformSumbitData();
            let result = true; 
            result = await this.addApply(this.form);
            if (!result) return;  // 已经提交注册表单了;
            this.submitCustomForm(formFill);
        },
        async addApply(form){ // 注册
            let opt = {
                exhibitionId:this.exhibitionId,
                userId:this.user.userId,
                ...form,
            }
            let result =  await this.addExApply(opt);
            return new Promise((resolve, reject) => {
                if(result.result){ // 注册成功
                    this.formUserId = result.data;
                    resolve(true);
                } else{  // 注册失败
                    this.$toast.fail(result.message);
                    resolve(false);
                }
            })
        },
        async submitCustomForm(formFill){ // 提交自定义注册表单数据
            const reqBody = { 
                itemId: this.exhibitionId, 
                formId:this.formId, 
                userId: this.formUserId,    // 展商自定义的userId用申请参展的成功返回的id;
                items: formFill 
            };   
            let result =  await this.addCustomForm(reqBody);
            if(result.result) {
                // this.$toast.success('提交成功，请耐心等待审核...');
                // setTimeout(()=>{
                //     this.$router.go(-1);
                // },1000)
                this.linkToExApplyFinish();
            } else {
                this.$toast.fail(result.message);
            }
        },
        async transformSumbitData() { // 转换数据为提交的表单
            return new Promise((resolve, reject) => {
                const valArr = [];
                this.formModel.forEach((v, i) => {
                    if (v.type === 10) return;
                    let obj = {};
                    let objArr = []; 
                    if (v.type === 7) { // 日期区间
                        const dateRange = [v['model' + i][0].start, v['model' + i][0].end]; 
                        valArr.push({
                                label: v.labelParent, 
                                Value: '', 
                                tagType: v.type,
                                childrens:[
                                    {label:v.label[0],Value: v['model' + i][0].start},
                                    {label:v.label[1],Value: v['model' + i][0].end,}
                                ]
                            });
                        return;
                    }
                    if (v.type === 5) { 
                        valArr.push({label: v.label, Value: JSON.stringify(v['model' + i]), tagType: v.type});
                        return;
                    } 
                    if (v.type === 11 && v.label === '城市') { 
                        valArr.push({label: '城市', Value: v['model' + i], tagType: v.type}); 
                        return;
                    }   
                    obj = {label: v.label, Value: v['model' + i], tagType: v.type}; 
                    valArr.push(obj);
                });  
                this.fillDefaultFormValue(valArr);
                resolve(valArr);
            });
        },
        fillDefaultFormValue(Data) { // 填充观众注册默认提交数据
            if(!Data) return; 
            Data.forEach(c => { 
                switch (c.label) {
                case '姓名':
                    this.form.fullName = c.Value;
                    break;
                case '手机':
                case '手机号':
                    this.form.phoneNumber = c.Value;
                    break;
                case '公司':
                    this.form.compName = c.Value;
                    break;
                case '拟参展类别':
                    this.form.categoies = c.Value;
                    break; 
                }
            }); 
            console.log(this.form,'注册的表单数据')
        },

        validForm() { // 根据类型验证表单 
            let valid = true;
            let errorTxt = '表单验证未通过'; 
            this.formModel.map((v, i) => { // 批量验证 表单选项
                if (!valid)return;
                switch (v.type) {
                    case 0: // 单行文本   
                    case 1: // 多行文字   
                        valid = this.setRegRule(v['model' + i],v.attributes.checkOptions);
                        if (!valid) {
                            errorTxt = `${v.label},验证未通过`;
                        } 
                        break;
                    case 3: // 下拉选择框
                        valid = this.checkFormItem(v.attributes, v['model' + i]);
                        if (!valid) {
                            errorTxt = `${v.label}选项为空,` + errorTxt;
                        } 
                        break;
                    case 4: // 单选
                        valid = this.checkFormItem(v.attributes, v['model' + i]);
                        if (!valid) {
                        errorTxt = `${v.label}选项为空,` + errorTxt;
                        } 
                        break;
                    case 5: // 多选
                        valid = this.checkFormItem(v.attributes, v['model' + i]);
                        if (!valid) {
                        errorTxt = `${v.label}最少选择一项`;
                        } 
                        break;
                }
            });
            if (!valid) {
                this.$toast.fail(errorTxt)
            } 
            return valid;
        },
        checkFormItem (v, control) { // 检查单个表单 必填等
            const checkOpt = v.checkOptions;
            let valid = true;  
            if (checkOpt && checkOpt.require && String(control) === '') { // 验证必填
                valid = false;
            }  
            return valid;
        },

        confirm(e,type){ // 下拉菜单的选项
          console.log(e,type,'下拉菜单的选项');
          if(type == 1) {
              this.formModel[this.curIndex]['model' + this.curIndex] = e;
              this.formModel[this.curIndex].isShow = false;
          } 
          if(type == 2) {
            let time = new Date(e);
            let date =this.timeFormat(time);
            console.log(date,'日期2');
            this.formModel[this.curIndex]['model' + this.curIndex] = date;
            this.formModel[this.curIndex].isShow = false;
          }
          if(type == 3) {
            let time = new Date(e);
            let date = this.timeFormat(time);
            console.log(date,'日期2');
            if(this.isStart){
                this.formModel[this.curIndex]['model' + this.curIndex][0].start = date;
                this.formModel[this.curIndex].isShow = false;
            } else {
                this.formModel[this.curIndex]['model' + this.curIndex][0].end = date;
                this.formModel[this.curIndex].isShow = false;
            }
          }
        },
        timeFormat(time) { // 时间格式化 2019-09-08
            let year = time.getFullYear();
            let month = time.getMonth() + 1;
            let day = time.getDate();
            return year + '-' + this.appendZero(month) + '-' + this.appendZero(day)
        },
        appendZero (obj) {
            return obj < 10 ? "0" + obj : obj 
        },
        confirmHall(e){ // 展馆选择 , 参展类别
            this.formModel[this.curIndex]['model' + this.curIndex] = e;
            this.formModel[this.curIndex].isShow = false;
        },
        setRegRule(val,rules) { // 根据验证选项返回验证规则
            const ruleArr = Object.keys(rules);
            let ruleStr = true;
            ruleArr.forEach(c => {
                if (c === "phone" && rules[c]) {
                ruleStr = /^1[3456789]\d{9}$/.test(val);
                }
                if (c === "email" && rules[c]) {
                ruleStr = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/.test(val);
                }
                if (c === "idCard" && rules[c]) { // 身份证
                ruleStr = /(^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$)/.test(val);
                }
                if (c === "other" && rules[c] !== "") {
                    let reg = rules[c].replace(/^(\s|\/)+|(\s|\/)+$/g, '');
                    let regExp = new RegExp(reg);
                    ruleStr = regExp.test(val);
                }
            });
            return ruleStr;
        },
        
        //手机号校验
        validatorPhone(val) {
            return /^1[3456789]\d{9}$/.test(val);
        },
        // 获取手机号验证码
        async getCode(phone){
            this.form.Phone = phone;
            if (!this.validatorPhone(phone)) {
                this.$toast.fail('请输入正确的手机号')
                return;
            } else {
                this.newDownTime();
                let res = await this.sendCode({
                PhoneNumber: phone
                });
                if (res.result) {
                this.codeKey = res.data.key;
                } else {
                this.$toast.fail('发送失败')
                }
            }
        },
        //验证手机号
        async Checkphone() {
            let res = await this.validateCode({
                key: this.codeKey,
                code: this.code
            });
            return new Promise((resolve, reject) => {
                if (res == true) {
                this.resetDown();
                resolve(true);
                } else {
                this.$toast.fail('手机号验证失败')
                this.resetDown();
                resolve(false);
                }
            })
        },


        resetDown(){ // 重置验证码
            clearInterval(this.newTimer);
            this.newCount = 0;
            this.newTimer = null;
            this.code = "";
        },

        //新手机号倒计时
        newDownTime() {
            const newTIME_COUNT = 60;
            if (!this.newTimer) {
                this.newCount = newTIME_COUNT;
                const newTimer = setInterval(() => {
                let count = this.newCount;
                if (count > 0 && count <= newTIME_COUNT) {
                    count--;
                    this.newCount = count;
                } else {
                    clearInterval(this.newTimer);
                    this.newTimer = null;
                }
                }, 1000);
                this.newTimer = newTimer;
            }
        },
    },
}
</script>
<style lang="scss" scoped>
.goods-box {
  width: 100%;
  min-height: 100vh;
  background-color: rgb(245, 245, 245);
  display: flex;
  flex-direction: column;
  align-items: center;
//   padding-bottom: .5rem;
  img {
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 50%;
    margin:.45rem 0;
  }
  .custom-form{
    width: 100%;
    padding-bottom: .9rem;
    .code{
        font-size: .3rem;
    }
    .sendcode{
        color: #0190fe;
    }
    .single-checkbox{
        margin:.6rem 0 .8rem .3rem;
        display: flex;
        p{
           font-size: .3rem; 
           margin-left: 5px;
           color: #666;
        }
        span{
            font-size: .3rem;
            color: #1890ff
        }
    }
    .vant-btn{
        position: fixed;
        left:0;
        bottom: 0;
        z-index: 100;
        width: 100%;
        background: #fff;
        height: .94rem;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0px 0px 3px 0px 
        rgba(0, 0, 0, 0.2);
        .van-button--block{
            width: 6.5rem;
            height: .74rem;
            line-height: .74rem;
        }
        span{
            font-size: .3rem;
        }
    }
    ::v-deep .reg_from{
      .intro_title{
        height: 0.77rem;
        display: flex;
        align-items: center;
        padding-left: 0.3rem;
        font-size: 0.3rem;
        color: #333;
      }
      .van-cell{
        padding: 0 0.3rem;
        height: 0.98rem;
        display: flex;
        align-items: center;
        // justify-content: center;
        &.intro_cell{
          height: 2rem;
        }
        &.cate_cell{
          .van-cell__title{
            flex: 0.4;
          }
          
          .van-cell__value{
            text-align: left;     
            p{
              font-size: 0.3rem;
              span{
                font-size: 0.3rem;
                color:#ff5c00 ;
              }
            }
          }
        }
        .van-field__label{
          color: #333;
        }
        .van-cell__value{
          .van-field__control{
             color:#666666;
          }
          span{
            font-size: .3rem;
          }
        }
      }
    }

    }
}
.cell-box{
    margin-bottom:10px;
}
.cell{
    // padding: 0 .3rem;
    &-title{
        font-size: .3rem;
        margin:10px .3rem;
        color: #333;
    }
    .yd-checkbox_wrap{
        border: solid 1px #e5e5e5;
        border-radius: 5px;
        background: #fff;
        margin-bottom: 10px;
    }
    .yd-checkbox-list{
        display: flex;
        min-height: .98rem;
        align-items: center;
        padding: 8px 12px;
        border-bottom: 1px solid #e5e5e5;
        width: 100%;
        line-height: 1.2;
    }
    .yd-checkbox-list:last-child{
        border: none;
    }
    .van-radio__label{
        font-size: .3rem;
    }
}
.cell-1{
    padding: 0 .3rem;
    .cell-title{
        margin:10px 0;
    }
}
.tipInfo{
    margin: 10px .3rem ;
    font-size: .3rem;
    line-height: 1.5;
}
.require{
    position: relative;
}
.require::before {
    position: absolute;
    left: -8px;
    top: 6px;
    color: #ee0a24;
    font-size: 14px;
    content: '*';
}
</style>